<div
  class="modal-backdrop in"
  *ngIf="interactionModeIsCanvas$ | async"
  (mousedown)="$event.preventDefault()"
></div>

<!--
  Wrap in a form so that pressing enter does not propagate up to the full form
  in the production workspace, causing this output to lose keyboard focus.
 -->
<form
  [style.height]="annotationHeight$ | async"
  [style.width]="annotationWidth$ | async"
>
  <!--
    Create hidden submit button so that pressing on enter does not submit the
    form
  -->
  <button class="hidden" type="submit"></button>

  <h3-loading-overlay
    [show]="interactionModeIsNone$ | async"
    [translucent]="true"
  >
    <ng-container [ngSwitch]="status$ | async">
      <p *ngSwitchCase="'error'" class="alert alert-danger">
        {{ errorMessage$ | async }}
      </p>
      <div
        *ngSwitchCase="'ready'"
        #focusableContainer
        class="focusable layout-focusable-container"
        tabindex="1"
        (keydown)="onKeyboardEvent($event)"
        (keyup)="onKeyboardEvent($event)"
        (focusout)="onFocusOut($event)"
        (focusin)="onFocusIn()"
        [class.split-view]="isInSplitView$ | async"
        [class.selected-output]="isSelectedOutput$ | async"
      >
        <div
          class="grid-section-layout"
          [class.split-view]="isInSplitView$ | async"
          [class.objects]="isObjectsEnabled && (isThumbnail$ | async) === false"
        >
          <ng-container
            *ngIf="
              isObjectsEnabled &&
              (isInSplitView$ | async) === false &&
              (isSelectedOutput$ | async)
            "
          >
            <div class="grid-global-toolbar">
              <ng-content
                select="[projection-location='global-toolbar']"
              ></ng-content>
            </div>
          </ng-container>

          <div
            class="grid-main-display"
            #mainDisplay
            [class.canvas-mode]="interactionModeIsCanvas$ | async"
            [class.thumbnail-mode]="isThumbnail$ | async"
            (contextmenu)="$event.preventDefault()"
          >
            <h3-loading-overlay [show]="interactionModeIsScrubber$ | async">
              <ng-content
                select="[projection-location='main-image']"
              ></ng-content>
              <ng-content
                select="[projection-location='floating-dialogs']"
              ></ng-content>
              <ng-container
                *ngIf="(isThumbnail$ | async) === false && isObjectsEnabled"
              >
                <ng-content
                  select="[projection-location='measure-toolbar']"
                ></ng-content>
              </ng-container>

              <ng-content
                select="[projection-location='toolbars']"
              ></ng-content>
            </h3-loading-overlay>
          </div>

          <div
            class="grid-right-collapsing-section"
            [hidden]="isRightPanelHidden$ | async"
          >
            <ng-content
              select="[projection-location='right-collapsing-section']"
            ></ng-content>
          </div>
          <div
            class="grid-timeline-section"
            [hidden]="isTimelineHidden$ | async"
          >
            <ng-content
              select="[projection-location='timeline-section']"
            ></ng-content>
          </div>
        </div>
      </div>
    </ng-container>
  </h3-loading-overlay>
</form>
